import { parseISO } from 'date-fns';
import type { QueryParameterConfig } from '../hooks';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const DateParameter = {
  decode(value?: Array<null | string> | null | string): Date | undefined {
    if (typeof value === 'string') {
      return parseISO(value);
    }

    return undefined;
  },

  default: undefined,
  encode(value?: Date) {
    return value?.toISOString();
  },
} satisfies QueryParameterConfig<Date | undefined>;
